module.exports = __webpack_public_path__ + "static/media/How-Teck-Lim.55d98ab8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/How-Teck-Lim.webp
// module id = 88
// module chunks = 0